import type { HuntStats } from '@cloudfruit-hunts/shared';
import { Countdown } from '../common/Countdown';

interface LiveStatsProps {
  stats: HuntStats;
}

export function LiveStats({ stats }: LiveStatsProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <p className="text-2xl font-bold text-primary">{stats.activePlayers}</p>
          <p className="text-xs text-text-light">Hunting Now</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-secondary">{stats.totalPlayers}</p>
          <p className="text-xs text-text-light">Total Players</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-accent">{stats.totalSolved}</p>
          <p className="text-xs text-text-light">Completions</p>
        </div>
      </div>

      {stats.mainPrizeClaimed ? (
        <div className="bg-accent bg-opacity-10 text-accent text-sm font-medium px-3 py-2 rounded-lg text-center">
          Main Prize Claimed!
        </div>
      ) : (
        <div className="bg-green-50 text-green-700 text-sm font-medium px-3 py-2 rounded-lg text-center">
          $150 Main Prize Still Available
        </div>
      )}

      {stats.openSeasonEndsAt && (
        <div className="text-center">
          <p className="text-xs text-text-light mb-1">Open Season Ends In</p>
          <Countdown targetDate={stats.openSeasonEndsAt} compact />
        </div>
      )}
    </div>
  );
}
